export default __webpack_public_path__ + "static/media/Path -1.17ef5595.png";